import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { QueryEmitter } from "./query.emitter/query.emiter";
import { QueryEmitterProvider } from "./query.emitter/query.emitter.provider";
import { CommonLibModule } from "@nrwl/common-lib";
import { QueryEmitterNoDataMessageComponent } from "./components/no.data.message/no.data.message.component";

@NgModule({
  imports: [CommonModule, CommonLibModule],
  providers: [
    {
      provide: QueryEmitter,
      useClass: QueryEmitterProvider
    }
  ],
  declarations: [QueryEmitterNoDataMessageComponent],
  exports: [QueryEmitterNoDataMessageComponent]
})
export class QueryEmitterModule {}
